module.exports = __webpack_public_path__ + "img/pause.73e02052.svg";